<template>
    <label>
        <div class="control">
            <input type="checkbox" v-bind="$attrs" :value="value" v-on="listeners"/>
            <div class="input">
                <img v-show="value" src="../../assets/img/check.svg"/>
            </div>
        </div>
        <div class="text">
            <slot/>
        </div>
    </label>
</template>
<script>
export default {
    name: 'Checkbox',
    inheritAttrs: false,
    props: {
        value: Boolean,
    },
    computed: {
        listeners () {
            return {
                ...this.$listeners,
                input: this.onInput,
            };
        },
    },
    methods: {
        onInput (e) {
            this.$emit('input', e.target.checked);
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';
@import '../../assets/scss/colors';

label {
    display: flex;
    align-items: flex-start;

    > .control {
        flex: 0 0 auto;
        margin-right: 20px;

        // Raw input
        > input[type="checkbox"] {
            display: none;

            // Custom input
            + .input {
                @include square(20px);
                border: 2px solid $grey-dark;
                border-radius: 4px;
                cursor: pointer;

                > img {
                    @include square(100%);
                }
            }

            &:checked + .input {
                border-color: $green;
            }
        }
    }

    > .text {
        flex: 1 1 auto;
        text-align: left;
        line-height: 1.5;
    }
}
</style>
